import i18next from 'i18next';

// Helper function to extract error message from various response formats
export const getErrorMessage = (error) => {
  if (error.response?.data) {
    const detail = error.response.data.detail;

    // --- DEBUG LOG ---
    console.log('🔍 [DEBUG] Backend Message:', detail);
    console.log('🔍 [DEBUG] Current Language:', i18next.language);
    console.log('🔍 [DEBUG] Translation Attempt:', `errors.invalidCredentials`);
    // -----------------

    if (typeof detail === 'string') {
      // Try to translate common backend messages
      return translateBackendMessage(detail);
    } else if (Array.isArray(detail)) {
      // Pydantic validation errors return an array
      const firstError = detail[0];
      if (firstError?.msg) {
        // Check for specific Pydantic email validation error
        if (firstError.msg.includes('value is not a valid email address')) {
          return i18next.t('errors.invalidEmail');
        }
        return translateBackendMessage(firstError.msg);
      } else if (typeof firstError === 'string') {
        return translateBackendMessage(firstError);
      } else if (firstError?.type === 'value_error.email') {
        return i18next.t('errors.invalidEmail');
      }
    } else if (detail?.msg) {
      return translateBackendMessage(detail.msg);
    } else if (detail?.message) {
      return translateBackendMessage(detail.message);
    }
  }

  // Check for network errors
  if (error.message === 'Network Error') {
    return i18next.t('errors.networkError');
  }

  return i18next.t('errors.generic');
};

// Helper function to translate common backend messages
const translateBackendMessage = (message) => {
  // Map of backend messages to translation keys
  const messageMap = {
    'Email ou senha incorretos': 'errors.invalidCredentials',
    'Invalid email or password': 'errors.invalidCredentials',
    'Conta de usuário desativada': 'errors.accountDisabled',
    'Account disabled': 'errors.accountDisabled',
    'Email já está em uso por outro usuário': 'errors.emailAlreadyExists',
    'Email is already in use': 'errors.emailAlreadyExists',
    'Nome de usuário já está em uso por outro usuário': 'errors.usernameAlreadyExists',
    'Username is already in use': 'errors.usernameAlreadyExists',
    'Usuário não encontrado': 'errors.userNotFound',
    'User not found': 'errors.userNotFound',
    'Token inválido ou expirado': 'errors.invalidToken',
    'Invalid or expired token': 'errors.invalidToken',
    'TMDB API key not configured': 'errors.apiKeyNotConfigured',
    'Chave da API TMDB não configurada': 'errors.apiKeyNotConfigured',
    'Idioma inválido. Use \'en\' ou \'pt-BR\'': 'errors.invalidLanguage',
    'Invalid language': 'errors.invalidLanguage',
    'Idioma do sistema inválido. Use \'en-US\' ou \'pt-BR\'': 'errors.invalidLanguage',
    'Invalid system language': 'errors.invalidLanguage',
    'Email not verified': 'auth.emailNotVerified',
    'Email não verificado. Verifique seu email.': 'auth.emailNotVerified',
    'Código de verificação inválido': 'auth.invalidCode',
    'Invalid verification code': 'auth.invalidCode',
    'Código de verificação expirado': 'auth.expiredCode',
    'Verification code expired': 'auth.expiredCode',
    'Registro de novos usuários está desabilitado': 'auth.registrationDisabled',
    'Registration is disabled': 'auth.registrationDisabled',
    'Erro ao enviar email de verificação': 'errors.emailSendError',
    'Error sending verification email': 'errors.emailSendError',
  };

  // Check if we have a translation for this message
  if (messageMap[message]) {
    return i18next.t(messageMap[message]);
  }

  // Check for partial matches
  for (const [key, value] of Object.entries(messageMap)) {
    if (message.includes(key)) {
      return i18next.t(value);
    }
  }

  // Return original message if no translation found
  return message;
};
